import { gql } from '@apollo/client';

const GET_GROUPS = gql`
  query getGroupsPaged(
    $take: Int!
    $skip: Int!
    $query: QueryGroups
    $order: [[String]]
  ) {
    getGroupsPaged(
      pagination: { take: $take, skip: $skip }
      query: $query
      order: $order
    ) {
      data {
        id
        name
      }
      pagination {
        skip
        take
        total
      }
    }
  }
`;

export { GET_GROUPS };
